module.exports = __webpack_public_path__ + "static/media/ic-faq.3c5932a8.svg";